import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
  ViewEncapsulation
} from '@angular/core';
import {NgModel} from "@angular/forms";
import {ValidationService} from "../../../util/service/validation/validation-service";
import {CalendarType, DatePickerMode, RangeInputLabels, TimeValueType, ValueFormat} from '@s.motevalian/persian-date-time-picker';

@Component({
  selector: 'app-frontend-date',
  standalone: false,
  templateUrl: './frontend-date.component.html',
  styleUrls: ['./frontend-date.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class FrontendDateComponent implements OnInit {
  @Input()
  value: Date | string | null = null;
  @Input()
  visibleTimePicker: boolean = false;
  @Input()
  type?: string;
  @Input()
  rtl: boolean = true;
  @Input()
  calendarType: CalendarType = "jalali";
  @Input()
  mode: DatePickerMode = "day";
  @Input()
  isRange: boolean = false;
  @Input()
  format?: string = "yyyy/MM/dd HH:mm";
  @Input()
  footerDescription: string = '';
  @Input()
  title: string = '';
  @Input()
  rangeInputLabel?: RangeInputLabels;
  @Input()
  disabled: boolean = false;
  @Input()
  required: boolean = false;
  @Input()
  showSidebar: boolean = true;
  @Input()
  valueFormat: ValueFormat = "date";
  @Input()
  showToday: boolean = true;
  @Input()
  isInline: boolean = false;
  @Input()
  minDate?: Date | string = undefined;
  @Input()
  maxDate?: Date | string = undefined;
  @Input()
  allowEmpty: boolean = true;
  @Input()
  readOnly: boolean = false;
  @Input()
  readOnlyInput: boolean = false;
  @Input()
  showIcon: boolean = true;
  @Input()
  timeValueType: TimeValueType = "string";
  @Input()
  timeDisplayFormat: string = 'HH:mm:ss';
  @Input()
  maxTime?: string = undefined;
  @Input()
  minTime?: string = undefined;
  @Output()
  valueChange: EventEmitter<string | Date | null> = new EventEmitter();
  @ViewChild('inputControl', {static: true})
  inputControl?: NgModel;

  constructor(private validationService: ValidationService, private cdr: ChangeDetectorRef) {
  }

  ngOnInit() {
    this.validationService.validate$.subscribe(() => {
      this.checkValidity();
    });
  }

  onTouched() {
    if (this.inputControl) {
      this.inputControl!.control.markAsTouched();
    }
    this.cdr.detectChanges();
  }

  checkValidity() {
    const isValid = this.required && (this.value === undefined || this.value === null || this.value === '');
    if (this.inputControl && this.inputControl.control) {
      this.inputControl.control.markAsTouched();
      this.inputControl.control.setErrors(isValid ? null : {required: true});
    }
  }

  onChangeDate(event: Date | string | null) {
    if (event === null || event === undefined || event === '') {
      this.value = null;
    } else {
      this.value = event;
    }
    this.valueChange.emit(this.value);
  }
}
